import { render, staticRenderFns } from "./GImageInput.vue?vue&type=template&id=42c68746&scoped=true&"
import script from "./GImageInput.vue?vue&type=script&lang=ts&"
export * from "./GImageInput.vue?vue&type=script&lang=ts&"
import style0 from "./GImageInput.vue?vue&type=style&index=0&id=42c68746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c68746",
  null
  
)

export default component.exports